<template>
  <div class="profile-container">
    <v-card flat class="futuristic-card">
      <v-card-title class="card-header">
        <div>
          <h4 class="earth-color">MY PROFILE</h4>
          <div class="title-decoration"></div>
          <p class="subtitle">Manage your personal information</p>
        </div>
      </v-card-title>
      
      <v-container>
        <v-form @submit.prevent="updateProfile()">
          <v-layout row wrap>
            <!-- Personal Information Section -->
            <v-flex lg12 md12 sm12 xs12>
              <div class="section-title">Personal Information</div>
            </v-flex>
            
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-text-field
                  label="First Name"
                  v-model="user.first_name"
                  :rules="requiredRules"
                  required
                  prepend-icon="person"
                  class="futuristic-input"
                  outlined
                  dense
                ></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-text-field
                  label="Last Name"
                  v-model="user.last_name"
                  :rules="requiredRules"
                  required
                  prepend-icon="person"
                  class="futuristic-input"
                  outlined
                  dense
                ></v-text-field>
              </v-container>
            </v-flex>
            
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-text-field
                  label="Email Address"
                  v-model="user.email"
                  :rules="requiredRules"
                  required
                  type="email"
                  disabled
                  prepend-icon="email"
                  class="futuristic-input"
                  outlined
                  dense
                ></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-text-field
                  label="Phone Number"
                  placeholder="e.g. 1-347382374"
                  v-model="user.phone_number"
                  :rules="requiredRules"
                  required
                  type="tel"
                  prepend-icon="phone"
                  class="futuristic-input"
                  outlined
                  dense
                ></v-text-field>
              </v-container>
            </v-flex>

            <!-- Account Information Section -->
            <v-flex lg12 md12 sm12 xs12>
              <div class="section-title">Account Information</div>
            </v-flex>
            
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-text-field
                  label="User Type"
                  v-model="user.user_type_display"
                  disabled
                  prepend-icon="verified_user"
                  class="futuristic-input"
                  outlined
                  dense
                ></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-text-field
                  label="Member Since"
                  v-model="user.registered_on"
                  disabled
                  prepend-icon="event"
                  class="futuristic-input"
                  outlined
                  dense
                ></v-text-field>
              </v-container>
            </v-flex>

            <!-- Action Buttons -->
            <v-flex lg12 md12 sm12 xs12>
              <v-container>
                <v-divider class="my-4"></v-divider>
              </v-container>
            </v-flex>
            
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-btn 
                  :depressed="true" 
                  color="#587e27" 
                  type="submit" 
                  block
                  :loading="loading"
                  class="futuristic-btn"
                >
                  <v-icon left small>save</v-icon>
                  SAVE CHANGES
                </v-btn>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-btn 
                  :depressed="true" 
                  color="error" 
                  block 
                  @click="goBack"
                  class="futuristic-btn"
                >
                  <v-icon left small>arrow_back</v-icon>
                  GO BACK
                </v-btn>
              </v-container>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'MyProfile',
  data() {
    return {
      loading: false,
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      user: {
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        public_id: '',
        user_type: '',
        user_type_display: '',
        registered_on: ''
      }
    }
  },
  computed: {
    userPublicId: function() {
      var unem = localStorage.getItem('unem')
      if (unem) {
        try {
          var parsed = JSON.parse(unem)
          if (parsed.public_id) return parsed.public_id
        } catch(e) {}
      }
      return localStorage.getItem('user_public_id') || null
    }
  },
  created: function() {
    this.loadProfile()
  },
  methods: {
    loadProfile: function() {
      var self = this
      var userId = self.userPublicId
      
      if (!userId) return
      
      self.user.public_id = userId
      
      self.$store.dispatch('get_user', userId)
        .then(function(user) {
          if (user) {
            self.user.first_name = user.first_name || ''
            self.user.last_name = user.last_name || ''
            self.user.email = user.email || ''
            self.user.phone_number = user.phone_number || ''
            self.user.user_type = user.user_type_public_id || user.user_type || ''
            self.user.user_type_display = user.user_type || ''
            self.user.registered_on = self.formatDate(user.registered_on)
          }
        })
        .catch(function() {
          var userData = JSON.parse(localStorage.getItem('unem'))
          if (userData) {
            self.user.first_name = userData.first_name || ''
            self.user.last_name = userData.last_name || ''
            self.user.email = userData.email || ''
            self.user.phone_number = userData.phone_number || ''
            self.user.user_type = userData.user_type_id || userData.user_type || ''
            self.user.user_type_display = userData.user_type || ''
          }
        })
    },
    updateProfile: function() {
      var self = this
      self.loading = true
      
      var updateData = {
        public_id: self.user.public_id,
        first_name: self.user.first_name,
        last_name: self.user.last_name,
        email: self.user.email,
        phone_number: self.user.phone_number,
        user_type: self.user.user_type,
        session_id: localStorage.getItem('lkjhgfdsa')
      }
      
      self.$store.dispatch('update_user', updateData)
        .then(function() {
          self.loading = false
          var userData = JSON.parse(localStorage.getItem('unem'))
          if (userData) {
            userData.first_name = self.user.first_name
            userData.last_name = self.user.last_name
            userData.phone_number = self.user.phone_number
            localStorage.setItem('unem', JSON.stringify(userData))
          }
        })
        .catch(function(error) {
          self.loading = false
        })
    },
    formatDate: function(date) {
      if (!date) return 'N/A'
      var parsedDate = this.$moment(date)
      if (!parsedDate.isValid()) return 'N/A'
      return parsedDate.format('MMM DD, YYYY')
    },
    goBack: function() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.profile-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.profile-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.subtitle {
  color: #6c757d;
  font-size: 0.9rem;
  margin-top: 4px;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 4px;
  width: 100px;
}

.section-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #587e27;
  margin: 16px 0 0 16px;
  letter-spacing: 1px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  margin-top: 8px;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #fafafa;
}

.futuristic-input >>> .v-input__slot:hover {
  background: #f5f7fa;
}

.futuristic-input >>> .v-input__slot fieldset {
  border-color: #e0e0e0;
  border-width: 1px;
}

.futuristic-input >>> .v-input__slot fieldset:hover {
  border-color: #587e27;
}

.futuristic-input >>> .v-input__slot.v-input--is-focused fieldset {
  border-color: #587e27;
  border-width: 2px;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

@media (max-width: 960px) {
  .profile-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.25rem;
  }

  .futuristic-btn {
    font-size: 0.9rem;
  }
}

@media (max-width: 600px) {
  .profile-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.1rem;
  }

  .section-title {
    margin: 8px 0 0 8px;
  }

  .futuristic-btn {
    font-size: 0.85rem;
  }
}
</style>